import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {SolverState} from "#template/runtime-graph/nodes/solver/state"
import type {SolverData} from "#template/runtime-graph/nodes/solver/data"
import type {ISceneManager} from "#template/interfaces/scene-manager"

const TD = TypeDescriptors

const solverDescriptor = {
    state: TD.inlet(TD.Identity<SolverState>()),
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    data: TD.inlet(TD.Identity<SolverData>()),
    updateAll: TD.outlet(TD.Function<(postStep: boolean) => void>()),
}

export class Solver implements NodeClassImpl<typeof solverDescriptor, typeof Solver> {
    static descriptor = solverDescriptor
    static uniqueName = "Solver"
    state!: Inlet<SolverState>
    sceneManager!: Inlet<ISceneManager>
    data!: Inlet<SolverData>
    updateAll!: Outlet<(postStep: boolean) => void>

    private _state: SolverState | undefined = undefined
    private _updateAllFn: ((postStep: boolean) => void) | undefined = undefined

    run() {
        if (this.state === NotReady || this.sceneManager === NotReady || this.data === NotReady) {
            this.updateAll.emitIfChanged(NotReady)
            return
        }

        this.state.update(this.sceneManager.getConnectionSolver(), this.data)

        if (this.state !== this._state) {
            this._state = this.state
            this._updateAllFn = this.state.runSolver.bind(this.state)
        }

        if (this._updateAllFn) this.updateAll.emitIfChanged(this._updateAllFn)
    }
}
